<template>
  <ul class="space-y-2">
    <NoteListItem
      v-for="note in notes"
      :key="note.id"
      :note="note"
      @update="fetchNotes"
      @destroy="$emit('destroy')"
    />
  </ul>
</template>

<script>
import { contactNotesClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import NoteListItem from './NoteListItem.vue';

export default {
  components: {
    NoteListItem,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      notes: [],
    };
  },
  created() {
    this.fetchNotes();
  },
  methods: {
    async fetchNotes(params = {}) {
      try {
        const response = await contactNotesClient.list(this.contactId, {
          ...params,
          include: 'user',
        });

        this.notes = mapKeysToCamelCase(response?.data || []);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
